import React from "react";

import * as Styled from "./styles";

import { ReactComponent as MenuIcon } from "shared/assets/svg/menu.svg";
import { Avatar, Badge, Menu, MenuItem, Typography, Box, Modal } from "@mui/material";

/*import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";*/
import { menuPatient } from "shared/mock";
import { DEFAULT_AVATAR } from "shared/config/properties";
import { CloseConsult } from "components/CloseConsult";
import { Documentation } from "components/Documentation";
import { ClinicalRecordUser, SimplifiedClinicalRecord } from "components/ClinicalRecord";
import { useClinical } from "shared/providers/Clinical";
import { useAuth } from "shared/providers/auth";
import { getAttendedConsultations } from "requests/Patient";
import { IAttendedConsultationsData } from "shared/types/Patient";
import { ROUTER } from "shared/constants/router";
import { EvolutionScreen } from "components/Evolution";
import { RecordPhysical } from "components/RecordPhysical";
import { ReferralStatusTracker } from "components/Referrals/StatusTracker";
import { ReturnButton } from "components/ReturnButton";
import { TreatmentPlan } from "components/TreatmentPlan";
import { WaitingPatients } from "components/WaitingPatients";

interface IProps {
  title: any;
  children?: any;
}

const HeadConsult: React.FC<IProps> = ({ title, children }) => {
  const { user, scheduleData } = useAuth();
  const { patientObj /*step*/ } = useClinical();

  const currentScheduleId = React.useMemo(() => {
    try {
      const raw = localStorage.getItem("personAttendance");
      if (raw) return JSON.parse(raw)?.id ?? null;
    } catch {}
    return null;
  }, []);

  const waitingCount = React.useMemo(() => {
    let count = 0;
    scheduleData.forEach((slot) => {
      slot.data?.forEach((item) => {
        if (
          (item.st_schedule === "C" || item.st_schedule === "T") &&
          item.inService !== 1 &&
          item.id !== currentScheduleId
        ) count++;
      });
    });
    return count;
  }, [scheduleData, currentScheduleId]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openClose, setOpenClose] = React.useState<boolean>(false);

  const [openCloseDocumentation, setOpenCloseDocumentation] =
    React.useState<boolean>(false);

  const [openCloseClinicalRecord, setOpenCloseClinicalRecord] =
    React.useState<boolean>(false);

  const [openCloseTreatment, setOpenCloseTreatment] =
    React.useState<boolean>(false);

  const [openEvolution, setOpenEvolution] = React.useState<boolean>(false);

  const [openPhysical, setOpenPhysical] = React.useState<boolean>(false);

  const [openReferrals, setOpenReferrals] = React.useState<boolean>(false);
  const [openSimplifiedRecord, setOpenSimplifiedRecord] = React.useState<boolean>(false);
  const [openWaitingPatients, setOpenWaitingPatients] = React.useState<boolean>(false);

  const [attendedConsultations, setAttendedConsultations] =
    React.useState<IAttendedConsultationsData | null>(null);

  const handleCamera = () => {
    //@ts-ignore
    if (window && window.ReactNativeWebView) {
      //@ts-ignore
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: "openCamera",
          value: "",
        })
      );
    }
  };

  React.useEffect(() => {
    const fetchAttendedConsultations = async () => {
      try {
        const { data, status } = await getAttendedConsultations(
          user.data.id,
          patientObj.pac_id
        );
        if ([200, 201].includes(status) && data.success) {
          setAttendedConsultations(data.data);
        }
      } catch (error) {
        console.error("Erro ao buscar consultas atendidas:", error);
      }
    };

    if (patientObj && patientObj.pac_id) {
      fetchAttendedConsultations();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientObj?.pac_id, user.data.id]);

  /* function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number }
  ) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column-reverse",
          gap: "10px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box>
          <Typography
            variant="body2"
            color="#007DED"
            sx={{ fontWeight: "500", fontSize: "18px" }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    );
  }

  function LinearWithValueLabel() {
    return (
      <Box sx={{ width: "100%" }}>
        <LinearProgressWithLabel
          value={step === 1 ? 50 : step === 2 ? 100 : 0}
        />
      </Box>
    );
  }*/

  return (
    <>
      <Styled.Box>
        <Styled.FakeBox></Styled.FakeBox>
        <Styled.Info>
          <Avatar
            src={
              patientObj && patientObj.pac_avatar && patientObj.pac_avatar
                ? patientObj.pac_avatar
                : DEFAULT_AVATAR
            }
            sx={{ width: "55px", height: "55px" }}
            alt={patientObj && patientObj.pac_name}
          />
          <Typography sx={{ color: "#919296", fontWeight: "500" }}>
            ID {patientObj && patientObj.pac_id_fant}
          </Typography>
          <Typography
            sx={{ color: "#343536", fontWeight: "bold", fontSize: "20px" }}
          >
            {patientObj && patientObj.pac_name}
          </Typography>
          {attendedConsultations && attendedConsultations.total_attended > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                gap: "6px",
                marginTop: "4px",
              }}
            >
              <Typography variant="body2" sx={{ color: "#666" }}>
                Consultas atendidas:
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{
                  backgroundColor: "#e3f2fd",
                  color: "#1565c0",
                  padding: "2px 8px",
                  borderRadius: "12px",
                }}
              >
                {attendedConsultations.total_attended}
              </Typography>
              {attendedConsultations.treatment_start_formatted && (
                <Typography variant="caption" color="textSecondary">
                  (desde {attendedConsultations.treatment_start_formatted})
                </Typography>
              )}
            </Box>
          )}
          {/*<LinearWithValueLabel /> */}
        </Styled.Info>
        <Styled.Menu>
          <button
            onClick={handleClick}
            style={{
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <Badge badgeContent={waitingCount} color="error" max={99}>
              <MenuIcon />
            </Badge>
          </button>
        </Styled.Menu>
      </Styled.Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {menuPatient.map((item, index) => (
          <div key={`menu-${index}`}>
            {item.href === "/PHYSICAL" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenPhysical(true)}>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/EVOLUTION" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenEvolution(true)}>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.text === "Tirar Foto" ? (
              <MenuItem key={index} onClick={handleCamera}>
                <Styled.NoLink>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/TRATAMENTO" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenCloseTreatment(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/DOC" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenCloseDocumentation(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/FICHA" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenCloseClinicalRecord(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/FICHA_RESUMIDA" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenSimplifiedRecord(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/ENCAMINHAMENTOS" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenReferrals(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/WAITING" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => { setOpenWaitingPatients(true); handleClose(); }}>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href !== ROUTER.CLOSE_CONSULT ? (
              <MenuItem key={index}>
                <Styled.Link href={item.href}>
                  {<item.icon />} {item.text}
                </Styled.Link>
              </MenuItem>
            ) : (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenClose(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            )}
          </div>
        ))}

        <Modal open={openClose} onClose={() => setOpenClose(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <CloseConsult
              close={() => setOpenClose(false)}
              idSchedule={patientObj && patientObj.id}
            />
          </Box>
        </Modal>

        <Modal
          open={openCloseDocumentation}
          onClose={() => setOpenCloseDocumentation(false)}
        >
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <Documentation
              onClick={() => setOpenCloseDocumentation(false)}
              idPacientParam={patientObj && patientObj.pac_id}
            />
          </Box>
        </Modal>

        <Modal
          open={openCloseClinicalRecord}
          onClose={() => setOpenCloseClinicalRecord(false)}
        >
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <ClinicalRecordUser
              onClick={() => setOpenCloseClinicalRecord(false)}
              idPacientParam={patientObj && patientObj.pac_id}
            />
          </Box>
        </Modal>

        <Modal
          open={openCloseTreatment}
          onClose={() => setOpenCloseTreatment(false)}
        >
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <TreatmentPlan
              onClick={() => setOpenCloseTreatment(false)}
              idPacientParam={patientObj && patientObj.pac_id}
            />
          </Box>
        </Modal>

        <Modal open={openEvolution} onClose={() => setOpenEvolution(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <EvolutionScreen
              onClick={() => setOpenEvolution(false)}
              idPacientParam={patientObj && patientObj.pac_id}
            />
          </Box>
        </Modal>

        <Modal open={openPhysical} onClose={() => setOpenPhysical(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <RecordPhysical
              onClick={() => setOpenPhysical(false)}
              idPacientParam={patientObj && patientObj.pac_id}
            />
          </Box>
        </Modal>

        <Modal open={openReferrals} onClose={() => setOpenReferrals(false)}>
          <Box
            sx={{ backgroundColor: "white", height: "100%", width: "100%", overflow: "auto" }}
          >
            <Box sx={{ padding: "16px" }}>
              <ReturnButton
                title="Encaminhamentos e Solicitações"
                onClick={() => setOpenReferrals(false)}
              />
              <ReferralStatusTracker pacienteId={patientObj && patientObj.pac_id} />
            </Box>
          </Box>
        </Modal>

        <Modal open={openSimplifiedRecord} onClose={() => setOpenSimplifiedRecord(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%", overflow: "auto" }}>
            <Box sx={{ padding: "16px" }}>
              <ReturnButton
                title="Ficha Resumida"
                onClick={() => setOpenSimplifiedRecord(false)}
              />
              <SimplifiedClinicalRecord idPacientParam={patientObj?.pac_id} />
            </Box>
          </Box>
        </Modal>

      </Menu>

      <WaitingPatients open={openWaitingPatients} onClose={() => setOpenWaitingPatients(false)} />

      {children}
    </>
  );
};

export { HeadConsult };
